module.exports = __webpack_public_path__ + "static/media/macroeconomics-not-enrolled.74efc0fc.svg";